import { render } from "./DashboardNavTop.vue?vue&type=template&id=70487864&scoped=true&ts=true&lang=pug"
import script from "./DashboardNavTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardNavTop.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardNavTop.vue?vue&type=style&index=0&id=70487864&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70487864"]])

export default __exports__